import * as React from 'react'

import { useSelector } from 'react-redux'
import { memoed, loadable } from '@library/react-toolkit'
import { Spin, Statistic } from 'antd'
import { record } from 'fp-ts'
import Amount from '../../Units/Amount'
import { FormattedMessage, useIntl } from 'react-intl'

type Props = { children?: React.ReactNode }

const Wallet = ({ children }: Props) => {
  const balance = useSelector(s =>
    record.toArray(memoed.extract(s.balance).balance)
  )
  const loading = useSelector(s => loadable.isLoading(s.balance.v))
  const intl = useIntl()

  return (
    <Spin spinning={loading}>
      {balance.length === 0 ? (
        <Statistic
          title={intl.formatMessage({ id: 'walletBalanceNoSymbol' })}
          value={intl.formatMessage({ id: 'emptyBalance' })}
        />
      ) : (
        balance.map(([u, a]) => (
          <Amount
            key={u}
            renderTitle={unitInfo => (
              <FormattedMessage id="walletBalance" values={unitInfo} />
            )}
            unit={u}
            amount={a}
          />
        ))
      )}
      {children}
    </Spin>
  )
}

export default Wallet
